// Server-only: never spread into externalLink, which is sent to the browser via /viewer.
// The SSO token is fetched server side by POST /pluxeeToken (network/appAPI.js).
export const pluxeeTokenRequest = {
    url: 'https://clients-api.cadeaux.pluxee.fr/client/token',
    headers: {
        'Content-Type': 'application/json',
        'client_id': '1aae793e-be2e-5ae6-bd90-4850e9c88366-1681476052',
        'client_secret': 'D3G7SrTFJNFxUCXOhYISNii2BgqZFE6B'
    }
}

export const modules = [
    {
        externalLink: {
            link: 'giftVouchers',
            redirect: 'services/gift/endowments/1/offerwall?view=news_view',
            module: 'giftVouchers'
        },
        object: 'CUser',
        name: 'giftVouchers',
        category: {
            path: 'myAdvantages',
            icon: 'gift'
        },
        displayLog: false,
        viewMap: {dt: ['registrationNumber']}
    },
    {
        externalLink: {
            link: 'cultureVouchers',
            redirect: 'services/gift/endowments/2/offerwall?view=news_view',
            module: 'cultureVouchers'
        },
        object: 'CUser',
        name: 'cultureVouchers',
        category: {
            path: 'myAdvantages',
            icon: 'gift'
        },
        displayLog: false,
        viewMap: {dt: ['registrationNumber']}
    },
    {
        externalLink: {
            link: 'tips',
            redirect: 'services/gift/endowments/3/offerwall?view=news_view',
            module: 'tips'
        },
        object: 'CUser',
        name: 'tips',
        category: {
            path: 'myAdvantages',
            icon: 'gift'
        },
        displayLog: false,
        viewMap: {dt: ['registrationNumber']}
    },
    {
        externalLink: {
            link: 'MyFairBook',
            module: 'myfairbook',
            simpleUrl: 'https://myfairbook.com'
        },
        object: 'CUser',
        name: 'MyFairBook',
        category: {
            path: 'myAdvantages',
            icon: 'gift'
        },
        displayLog: false,
        viewMap: {dt: ['registrationNumber']}
    }
]
